import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ClinicPicker, Header, MonthlyCostWidget, NewScannerWidget } from '../../components';
import { http } from '../../helpers';

function Dashboard() {
    const [tiers, setTiers] = useState(null);
    const [scanCount, setScanCount] = useState(null);
    const [cost, setCost] = useState(null);
    const [selectedClinic, setSelectedClinic] = useState('');
    const [newScannerWidget, setNewScannerWidgetData] = useState({ total: null, remaining: null });
    const [searchParams] = useSearchParams();

    const { scope } = localStorage;
    const scopeArray = (scope || '').split(' ');
    const hasAccess = (rule) => scopeArray.includes(rule);
    const canViewClinicsFilter = hasAccess('cases.display.clinics:read');
    const canReadSystemBilling = hasAccess('billing.system:read');
    const canReadBilling = hasAccess('billing:read');
    const currentMonth = moment(new Date()).format('MMMM');

    useEffect(() => {
        const param = searchParams.get('clinicId');
        if (!selectedClinic && param) setSelectedClinic(param);
    }, []);

    const getWidgetData = () => {
        if (canViewClinicsFilter && !selectedClinic) {
            setTiers(null);
            setNewScannerWidgetData({ remaining: null, total: null });
            return;
        }
        let relativeUrl = '/case-api/billing';
        if (selectedClinic) {
            relativeUrl += `?clinicId=${selectedClinic}`;
        }
        http
            .get(relativeUrl)
            .then(({ data: { billingTiers, count, total } }) => {
                const arr = billingTiers;
                arr.push({
                    order: 4,
                    quantity: 30,
                    cost: 0,
                });
                setTiers(arr);
                setScanCount(count);
                setCost(total);
            })
            .catch((error) => console.warn(error));

        let remainingScanUrl = '/case-api/scanners/progress';
        if (selectedClinic) {
            remainingScanUrl += `?clinicId=${selectedClinic}`;
        }
        http
            .get(remainingScanUrl)
            .then(({ data: { remaining, total } }) => {
                setNewScannerWidgetData({ remaining, total });
            })
            .catch((error) => console.warn(error));
    };

    useEffect(() => {
        getWidgetData();
    }, [selectedClinic]);

    return (
        <>
            <Header label="Dashboard" />
            <main className="dashboard-container">
                {canViewClinicsFilter && canReadSystemBilling && (
                    <Grid container>
                        <Grid item md={3}>
                            <ClinicPicker selectedClinic={selectedClinic} onSelectClinic={setSelectedClinic} />
                        </Grid>
                    </Grid>
                )}
                <Grid container>
                    <Grid item lg={6} xs={12}>
                        {canReadBilling && tiers && scanCount !== null && cost !== null && (
                            <>
                                <Typography variant="h6" sx={{ mb: 12, mt: 3 }}>
                                    {currentMonth}
                                    {' '}
                                    Scan Data
                                </Typography>
                                <MonthlyCostWidget count={scanCount} cost={cost} tiers={tiers} />
                            </>
                        )}
                        {newScannerWidget.remaining !== null && newScannerWidget.total !== null && (
                            <>
                                <Typography variant="h6" sx={{ mb: 12, mt: 15 }}>Remaining Months To New Scanner</Typography>
                                <NewScannerWidget remaining={newScannerWidget.remaining} total={newScannerWidget.total} />
                            </>
                        )}
                    </Grid>
                </Grid>
            </main>
        </>

    );
}
export default Dashboard;
